// Reusable helper function to limit decimals gracefully
export function limitDecimals(value: unknown, decimalPlaces: number): unknown {
    if (typeof value === 'number' && isFinite(value)) {
        return Number(value.toFixed(decimalPlaces));
    }
    return value;
}